export const chargeConstants = {
  CHARGE_REQUEST: 'CHARGE_REQUEST',
  CHARGE_SUCCESS: 'CHARGE_SUCCESS',
  CHARGE_FAILURE: 'CHARGE_FAILURE',
};
